module.exports = __webpack_public_path__ + "img/144.0709bffd.jpg";